import { CSSProperties, ReactElement } from 'react';

import ReportTableCell from '@/pages/Reports/DynamicReport/components/ReportTable/ReportTableCell';
import Table from '@/common/Table';
import { formatValue } from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/utils';
import { progressColorFromValue } from '@/pages/Reports/DynamicReport/components/ReportTable/components/StatusCell';

export type TrainingReportPdfDriversTableRowProps = {
  values: Record<string, string>;
  keys: string[];
};

const TrainingReportPdfDriversTableRow = ({ values, keys }: TrainingReportPdfDriversTableRowProps): ReactElement => {
  const progressColor = Object.values(values)
    .map(progressColorFromValue)
    .find((color) => color !== undefined);
  return (
    <Table.Row
      style={progressColor !== undefined ? ({ '--progress-color': progressColor } as CSSProperties) : undefined}
      virtualize={false}
    >
      {keys.map((key) => (
        <ReportTableCell className={key.toUpperCase()} key={key}>
          {formatValue(values[key])}
        </ReportTableCell>
      ))}
    </Table.Row>
  );
};

export default TrainingReportPdfDriversTableRow;
